"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faCircleCheck_1 = require("@fortawesome/pro-solid-svg-icons/faCircleCheck");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Box_1 = __importDefault(require("@mui/material/Box"));
var firestore_1 = require("firebase/firestore");
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var OutlinedTextButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/OutlinedTextButton"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var formatters_1 = require("utils/formatters");
var hooks_2 = require("utils/hooks");
var MAIN_ADDRESS_FIELDS = ['country', 'line1', 'city', 'postalCode'];
var Status = function (_a) {
    var _b, _c;
    var item = _a.item;
    var confirmedOn = (_c = (_b = item.rechCustomer) === null || _b === void 0 ? void 0 : _b.crawledMigrationCustomer) === null || _c === void 0 ? void 0 : _c.confirmedOn;
    var promptConfirm = (0, hooks_1.useConfirm)();
    var _d = __read((0, hooks_2.useSubmitter)('recharged_customers', item.rechCustomerId), 2), rechOrgSubmitter = _d[0], isSending = _d[1];
    var setMigrationMapConfirmation = function (migrationMapConfirmed) { return rechOrgSubmitter({
        crawledMigrationCustomer: { confirmedOn: migrationMapConfirmed ? firestore_1.Timestamp.now() : (0, firestore_1.deleteField)() },
    }); };
    // const track = useTracker();
    //
    // const undo = () => {
    //   track('Stripe Migrated Customer Reverted', {
    //     rechargedCustomerId: item.id,
    //     rechargedCustomerName: item.name,
    //     previousStripeMigratedCustomerName: item.stripeMigratedCustomer?.name,
    //     isSelectClear: true,
    //   });
    //   return setMigrationMapConfirmation(false);
    // };
    var undo = function () { return setMigrationMapConfirmation(false); };
    var confirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var address, fieldsToCheck, missingFields;
        var _a;
        return __generator(this, function (_b) {
            address = (_a = item.rechCustomer) === null || _a === void 0 ? void 0 : _a.address;
            fieldsToCheck = ['UK', 'NZ'].includes(address === null || address === void 0 ? void 0 : address.country)
                ? MAIN_ADDRESS_FIELDS
                : __spreadArray(__spreadArray([], __read(MAIN_ADDRESS_FIELDS), false), ['state'], false);
            if (address && fieldsToCheck.every(function (f) { return address === null || address === void 0 ? void 0 : address[f]; })) {
                return [2 /*return*/, setMigrationMapConfirmation(true)];
            }
            missingFields = fieldsToCheck.filter(function (f) { return !(address === null || address === void 0 ? void 0 : address[f]); });
            return [2 /*return*/, promptConfirm("Some fields missing in the customer's address", "Fields ".concat(missingFields.map(function (f) { return (0, formatters_1.camelToProper)(f); }).join(', '), " are missing"), 'red', 'OK', true)];
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ display: "inline-flex", alignItems: "center", width: 1, gap: 2.5, pl: 1.75 }, { children: confirmedOn
            ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ title: "Confirmed", variant: "dark" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faCircleCheck_1.faCircleCheck, color: "#30BC86" }) })), (0, jsx_runtime_1.jsx)(OutlinedTextButton_1.default, __assign({ isSending: isSending, color: "neutral", onClick: undo, className: "showOnHover" }, { children: "Undo" }))] }))
            : ((0, jsx_runtime_1.jsx)(OutlinedTextButton_1.default, __assign({ color: "green", isSending: isSending, onClick: confirm, disabled: !item.rechCustomerId, sx: !item.rechCustomerId ? { opacity: 0, cursor: 'default' } : {} }, { children: "Confirm" }))) })));
};
exports.default = Status;
